import React, { ReactNode, createContext, useContext, useState } from 'react';

interface SearchTypeContextValue {
  searchType: string;
  selectedSearchResult: string | null;
  setSelectedSearchResult: (result: string | null) => void;
  autoOrSerp: string | null;
  setAutoOrSerp: (value: string | null) => void;
}

const defaultContext: SearchTypeContextValue = {
  searchType: '',
  selectedSearchResult: '',
  setSelectedSearchResult: () => {},
  autoOrSerp: '',
  setAutoOrSerp: () => {},
};

const SearchTypeContext = createContext<SearchTypeContextValue>(defaultContext);

export const useSearchType = (): SearchTypeContextValue => {
  const context = useContext(SearchTypeContext);
  return context;
};

interface SearchTypeProviderProps {
  searchType: string;
  children: ReactNode;
}

export const SearchTypeProvider: React.FC<SearchTypeProviderProps> = ({ searchType, children }) => {
  const [selectedSearchResult, setSelectedSearchResult] = useState<string | null>(null);
  const [autoOrSerp, setAutoOrSerp] = useState<string | null>(null);

  const value = {
    searchType,
    selectedSearchResult,
    setSelectedSearchResult,
    autoOrSerp,
    setAutoOrSerp,
  };

  return <SearchTypeContext.Provider value={value}>{children}</SearchTypeContext.Provider>;
};
